export const css = {
    root: '_3Od9sEJl',
    ' _key': 'certwise-theme/dojo/variants/dark'
};
export default css;
